import { RootState } from '../app/rootReducer'

export const selectUserName = (state: RootState): string => state.user.userName
